'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _interceptUpdater = require('coact-utils/interceptUpdater');

var _interceptUpdater2 = _interopRequireDefault(_interceptUpdater);

var _flattenDefaultProp = require('coact-utils/flattenDefaultProp');

var _flattenDefaultProp2 = _interopRequireDefault(_flattenDefaultProp);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

var _withEditorSpliter = require('./withEditorSpliter');

var _withEditorSpliter2 = _interopRequireDefault(_withEditorSpliter);

var _validateValue = require('../inputs/enhancers/validateValue');

var _validateValue2 = _interopRequireDefault(_validateValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 使用時放置在其他 HOC 前
var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  schema: _propTypes.object,
  value: _propTypes.any,
  onChange: _propTypes.func,
  validator: _propTypes.func,
  computer: _propTypes.func
}), _withEditorSpliter2.default, // 位置都可以，反正 props 最後才會傳進來
(0, _flattenDefaultProp2.default)('schema'), // 應該儘量往前，因為當成 options 用
(0, _interceptUpdater2.default)('onChange', 'computer'), // 應該沒差，往上好
_validateValue2.default, (0, _exposeProps2.default)(['onChange', 'spliter']));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'objectEditorEnhancer');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/objectEditorEnhancer.js
// module id = 1763
// module chunks = 0